module.exports = __webpack_public_path__ + "static/media/fa-brands-400.83e6c29f.svg";